// Dependencies
import { combineReducers } from 'redux';

// Reducers
import core from 'Core/.globals/redux/reducers';
import maintenance from 'Modules/maintenance/.globals/redux/reducers';
import behavior from 'Modules/behavior/.globals/redux/reducers';
import fleet from 'Modules/fleet/.globals/redux/reducers';
import reports from 'Modules/reports/.globals/redux/reducers';
import entitySelector from 'Modules/.common/components/EntitySelector/redux/reducer';
import alerts from 'Modules/alerts/.globals/redux/reducers';
import realtimeMaps from 'Modules/realtimeMaps/.globals/redux/reducer';
import common from 'Modules/.common/.globals/redux/reducers';
import video from 'Modules/video/.globals/redux/reducers';
import account from 'Modules/account/.globals/redux/reducers';
import settings from 'Modules/settings/.globals/redux/reducers'; //! Remove old settings module progressively
import manage from 'Modules/manage/.globals/redux/reducers';
import dashboard from 'Modules/dashboard/.globals/redux/reducers';
import fsm from 'Modules/fsm/.globals/redux/reducers';
import dynamicForms from 'Modules/dynamicForms/.globals/redux/reducers';
import chat from '../../modules/chat/.globals/redux/reducers';
import routes from '../../modules/routes/.globals/redux/reducer';
import incidents from '../../modules/incidents/.globals/redux/reducers';
import workOrders from '../../modules/workOrders/.globals/redux/reducers';
import template from '../../modules/.template/.globals/redux/reducers';
import driver from '../../modules/driver/redux/reducers';
import driverPerformance from '../../modules/driverPerformance/.globals/redux/reducers';
import inspectionBuilderRedux from '../../modules/evirPx/tabs/inspectionBuilder/redux/slice';
import inspectionHistoryRedux from '../../modules/evirPx/tabs/inspectionHistory/redux/slice';
import inspectionDetailsRedux from '../../modules/evirPx/tabs/inspectionDetails/redux/slice';
import assetDetailsRedux from '../../modules/evirPx/tabs/assetDetails/redux/slice';
import defectsGtcRedux from '../../modules/evirPx/tabs/defectsGtc/redux/slice';
import accountSettingsRedux from '../../modules/account/views/settings/redux/slice';
import clipRequestDrawerMapRedux from 'Components/Map/components/ClipRequestDrawerMap/redux/slice';

// Phase 1 - Realtime RTK Reducers
import realtime from 'Core/realtime/redux/reducers';

const reducersModules = {
  ...core,
  ...maintenance,
  ...behavior,
  ...fleet,
  ...reports,
  ...entitySelector,
  ...alerts,
  ...realtimeMaps,
  ...common,
  ...video,
  ...account,
  ...fsm,
  ...settings,
  ...manage,
  ...dashboard,
  ...dynamicForms,
  ...chat,
  ...routes,
  ...incidents,
  ...workOrders,
  ...template,
  ...driver,
  ...driverPerformance,
  inspectionBuilderRedux,
  inspectionHistoryRedux,
  inspectionDetailsRedux,
  assetDetailsRedux,
  defectsGtcRedux,
  accountSettingsRedux,
  ...realtime,
};

const reducers = combineReducers(reducersModules);

export default reducers;
